import classnames from "classnames";
import React, { useContext } from "react";
import {
  RicosAlignmentContext,
  RicosDirectionHandledContext,
  RicosNodeContext,
  RicosNodeContextProvider,
  RicosViewerContext
} from "./../../../../../ricos-context";
import { TextStyle_TextAlignment } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import alignmentStyle from "../../../../statics/alignment.rtlignore-scss";
import indentStyle from "../../../../statics/indentation-scss";
import Anchorable from "../../utils/Anchorable";
import { getPaywallSeoClass, isPaywallSeo } from "../../utils/paywallSeo";
import { indentLevelToClassName } from "../consts";
import styles from "./heading-scss";
const levelToClassName = {
  1: "headerOne",
  2: "headerTwo",
  3: "headerThree",
  4: "headerFour",
  5: "headerFive",
  6: "headerSix"
};
const levelToTag = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6"
};
const FALLBACK_LEVEL = 1;
const Heading = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { seoMode } = useContext(RicosViewerContext);
  const { textAlignment: parentAlignment } = useContext(RicosAlignmentContext);
  const { parentNode } = useContext(RicosNodeContext);
  const directionHandled = useContext(RicosDirectionHandledContext);
  const { level = 0, textStyle, indentation = 0 } = node.headingData || {};
  const { textAlignment, lineHeight } = textStyle || {};
  const headingClassName = classnames(
    styles[levelToClassName[level] ?? levelToClassName[FALLBACK_LEVEL]],
    alignmentStyle[textAlignment || parentAlignment || TextStyle_TextAlignment.AUTO],
    indentStyle[indentLevelToClassName[indentation]],
    !parentNode && isPaywallSeo(seoMode) && getPaywallSeoClass(seoMode?.paywall || {}, nodeIndex)
  );
  const childClassName = classnames(
    styles.child,
    textAlignment === TextStyle_TextAlignment.JUSTIFY && alignmentStyle[textAlignment]
  );
  const Tag = levelToTag[level] ?? levelToTag[FALLBACK_LEVEL];
  const nodeStyle = node.style || {};
  lineHeight && (nodeStyle.lineHeight = lineHeight);
  const isEmpty = !node.nodes?.length;
  const doesEndWithSoftLine = !isEmpty && node.nodes?.[node.nodes.length - 1]?.textData?.text?.slice(-1) === "\n";
  const Content = isEmpty ? /* @__PURE__ */ React.createElement("br", { role: "presentation" }) : /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { key: `children-${node.id}`, nodes: node.nodes ?? [] }));
  return /* @__PURE__ */ React.createElement(Anchorable, { nodeId: node.id }, /* @__PURE__ */ React.createElement(Tag, { className: headingClassName, style: nodeStyle, dir: directionHandled ? "" : "auto" }, /* @__PURE__ */ React.createElement("span", { className: childClassName }, Content), doesEndWithSoftLine && /* @__PURE__ */ React.createElement("br", { role: "presentation" })));
};
const HeadingRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Heading, { key: node.id, node, ...props });
};
var heading_default = HeadingRenderer;
export {
  heading_default as default,
  levelToClassName
};
//# sourceMappingURL=heading.js.map
